/* Enhance native Combine controls; cart submission remains owned by product-form. */
(() => {
  if (window.cgPdpPolishInstalled) return;
  window.cgPdpPolishInstalled = true;
  const desktop = window.matchMedia('(min-width:1200px)');
  const navSelector = '.coolgreen-header-test .coolgreen-header-test__desktop-nav';
  const itemSelector = navSelector + ' .site-nav-container > nav > .link-list > .has-submenu';
  const closeTimers = new WeakMap();
  const boundMenus = new WeakSet();
  let menuCounter = 0;
  const triggerFor = item => item.querySelector(':scope > .menu-link');
  const panelFor = item => item.querySelector(':scope > .submenu');
  const items = () => Array.from(document.querySelectorAll(itemSelector));
  const measure = item => {
    const row = item.closest('.header__top');
    if (row) row.style.setProperty('--cg-menu-bottom', Math.max(0, Math.ceil(row.getBoundingClientRect().bottom)) + 'px');
  };
  function close(item, restoreFocus = false) {
    if (!item) return;
    clearTimeout(closeTimers.get(item));
    const trigger = triggerFor(item);
    if (restoreFocus) trigger?.focus({preventScroll:true});
    item.classList.remove('cg-menu-open', 'focus');
    delete item.dataset.cgOpenVia;
    trigger?.setAttribute('aria-expanded', 'false');
    item.removeAttribute('aria-expanded');
  }
  function open(item, via) {
    if (!desktop.matches) return;
    items().forEach(other => {if (other !== item) close(other);});
    clearTimeout(closeTimers.get(item));
    measure(item);
    item.classList.add('cg-menu-open', 'focus');
    item.dataset.cgOpenVia = via;
    triggerFor(item)?.setAttribute('aria-expanded','true');
  }
  function initMenus() {
    document.querySelectorAll(navSelector).forEach(nav => nav.classList.add('cg-menu-ready'));
    items().forEach((item,index) => {
      const trigger = triggerFor(item), panel = panelFor(item);
      if (!trigger || !panel) return;
      if (!boundMenus.has(item)) {
        boundMenus.add(item);
        // The native sticky header clones IDs. Give every panel its own control.
        panel.id = 'cg-desktop-panel-' + (++menuCounter);
        trigger.setAttribute('aria-controls', panel.id);
        trigger.setAttribute('aria-expanded','false');
        trigger.setAttribute('aria-haspopup','true');
        if (panel.classList.contains('mega-menu') && !panel.querySelector('.cg-menu-close')) {
          const tools = document.createElement('div');
          tools.className = 'cg-menu-tools';
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'cg-menu-close';
          button.textContent = document.documentElement.lang.startsWith('es') ? 'Cerrar menú' : 'Close menu';
          tools.append(button);
          (panel.querySelector('.submenu-holder') || panel).prepend(tools);
        }
      }
    });
  }
  document.addEventListener('pointerover', event => {
    if (!desktop.matches || event.pointerType === 'touch') return;
    const item = event.target.closest?.(itemSelector);
    if (item && !item.contains(event.relatedTarget)) open(item,'hover');
  });
  document.addEventListener('pointerout', event => {
    if (!desktop.matches) return;
    const item = event.target.closest?.(itemSelector);
    if (item && !item.contains(event.relatedTarget)) {
      clearTimeout(closeTimers.get(item));
      closeTimers.set(item, setTimeout(() => {
        if (!item.contains(document.activeElement)) close(item);
      },180));
    }
  });
  document.addEventListener('click', event => {
    if (!desktop.matches) return;
    const closer = event.target.closest?.('.cg-menu-close');
    if (closer) {event.preventDefault();close(closer.closest(itemSelector),true);return;}
    const trigger = event.target.closest?.(itemSelector + ' > .menu-link');
    if (trigger) {
      event.preventDefault(); event.stopImmediatePropagation();
      const item = trigger.parentElement;
      if (item.classList.contains('cg-menu-open') && item.dataset.cgOpenVia === 'click') close(item);
      else open(item,'click');
    } else {
      const current = event.target.closest?.(itemSelector);
      items().forEach(item => {if(item !== current)close(item);});
    }
  },true);
  document.addEventListener('keydown', event => {
    if (!desktop.matches) return;
    if (event.key === 'Escape') {
      const current = items().find(item => item.classList.contains('cg-menu-open'));
      if (current) {event.preventDefault();event.stopPropagation();close(current,true);}
      return;
    }
    const trigger = event.target.closest?.(itemSelector + ' > .menu-link');
    if (trigger && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();event.stopImmediatePropagation();
      const item = trigger.parentElement;
      if(item.classList.contains('cg-menu-open') && item.dataset.cgOpenVia === 'click')close(item);
      else open(item,'click');
    }
  },true);
  document.addEventListener('focusin', event => {
    if (!desktop.matches) return;
    const trigger = event.target.closest?.(itemSelector + ' > .menu-link');
    if (trigger && !trigger.parentElement.classList.contains('cg-menu-open')) open(trigger.parentElement,'focus');
  });
  document.addEventListener('focusout', event => {
    if (!desktop.matches) return;
    const item = event.target.closest?.(itemSelector);
    if (item && !item.contains(event.relatedTarget)) close(item);
  });
  desktop.addEventListener('change', () => items().forEach(item=>close(item)));
  let measureFrame = 0;
  function scheduleMeasure() {
    if (measureFrame) return;
    measureFrame = requestAnimationFrame(() => {
      measureFrame = 0;
      items().filter(item=>item.classList.contains('cg-menu-open')).forEach(measure);
    });
  }
  window.addEventListener('resize',scheduleMeasure,{passive:true});
  window.addEventListener('scroll',scheduleMeasure,{passive:true});

  const stickyBindings = new Map();
  function bindSticky(bar) {
    if (stickyBindings.has(bar)) return;
    const page = document.getElementById(bar.dataset.id);
    const button = bar.querySelector('button[data-js-atc]');
    const label = button?.querySelector('.button__text');
    if (!page || !button || !label) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const indicator = document.createElement('span');
    indicator.className = 'cg-sticky-state'; indicator.setAttribute('aria-hidden','true');
    button.prepend(indicator);
    const idleLabel = label.textContent;
    let confirmed = false, confirmTimer = 0;
    const mainButton = () => page.querySelector('[data-js-product-add-to-cart]');
    function sync() {
      const main = mainButton();
      if (!main) {button.disabled = true;return;}
      const busy = main.classList.contains((window.KT_PREFIX || '') + 'working') || main.getAttribute('aria-busy') === 'true';
      button.disabled = busy || main.disabled || main.classList.contains('disabled') || main.getAttribute('aria-disabled') === 'true';
      button.classList.toggle((window.KT_PREFIX || '') + 'working',busy);
      button.classList.toggle('cg-busy',busy);
      button.classList.toggle('cg-added',confirmed && !busy);
      button.setAttribute('aria-busy',String(busy));
      if(busy) label.textContent = bar.dataset.cgBusy;
      else if(confirmed) label.textContent = bar.dataset.cgAdded;
      else label.textContent = main.querySelector('.button__text')?.textContent.trim() || idleLabel;
    }
    function updateSelection() {
      const selection = page.querySelector('cg-product-addons')?.selection;
      const show = !!selection && (selection.count > 0 || selection.quantity > 1);
      bar.classList.toggle('cg-has-selection',show);
      const box = bar.querySelector('[data-cg-sticky-selection]');
      if(box) {
        box.hidden = !show;
        if(show) box.querySelector('[data-cg-sticky-total]').textContent = selection.formatted;
      }
    }
    button.addEventListener('click', event => {
      const main = mainButton();
      if(!main || main.disabled || main.classList.contains('disabled') || main.classList.contains((window.KT_PREFIX || '') + 'working')) {
        event.preventDefault();event.stopImmediatePropagation();sync();
      } else {
        confirmed = false;clearTimeout(confirmTimer);
        // The existing native click handler submits the main product form once.
        requestAnimationFrame(sync);
      }
    },{capture:true,signal});
    page.addEventListener('add-to-cart', () => {
      confirmed = true;clearTimeout(confirmTimer);sync();
      confirmTimer = setTimeout(()=>{confirmed=false;sync();},2400);
    },{capture:true,signal});
    page.addEventListener('cg:addons:change',updateSelection,{signal});
    page.addEventListener('change',()=>{confirmed=false;sync();},{signal});
    const observer = new MutationObserver(()=>{sync();updateSelection();});
    observer.observe(page,{attributes:true,attributeFilter:['class','disabled','aria-busy','aria-disabled'],childList:true,subtree:true});
    sync();updateSelection();
    stickyBindings.set(bar,()=>{controller.abort();observer.disconnect();clearTimeout(confirmTimer);indicator.remove();});
  }
  function scan() {
    initMenus();
    document.querySelectorAll('sticky-add-to-cart[data-cg-sticky]').forEach(bindSticky);
    stickyBindings.forEach((dispose,bar)=>{
      if(!bar.isConnected || !document.getElementById(bar.dataset.id)){dispose();stickyBindings.delete(bar);if(bar.isConnected)bar.remove();}
    });
  }
  document.addEventListener('click',event=>{
    const link=event.target.closest?.('[data-cg-back-to-product]');
    if(!link)return;
    const page=document.querySelector('.cg-pdp-main [data-js-product-component]');
    const target=page?.querySelector('cg-product-addons:not([hidden])') || page?.querySelector('product-variants') || page?.querySelector('[data-js-product-add-to-cart]');
    if(target){
      event.preventDefault();
      const control=target.matches('button,input,select')?target:target.querySelector('input,select,button');
      control?.focus({preventScroll:true});
      target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'});
    }
  });
  let scanFrame = 0;
  function queueScan() {
    if(scanFrame)return;
    scanFrame=requestAnimationFrame(()=>{scanFrame=0;scan();});
  }
  function start() {
    scan();
    new MutationObserver(records=>{
      if(records.some(record=>Array.from(record.addedNodes).some(node=>node.nodeType===1 && (node.matches?.('.coolgreen-header-test,sticky-add-to-cart,[data-js-product-component]') || node.querySelector?.('.coolgreen-header-test,sticky-add-to-cart,[data-js-product-component]')))))queueScan();
    }).observe(document.body,{childList:true,subtree:true});
    document.addEventListener('shopify:section:load',queueScan);
    document.addEventListener('shopify:section:unload',queueScan);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
